import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { GoogleMapsModule } from '@angular/google-maps';

import { ToastrModule } from 'ngx-toastr';
import { NgxCsvParserModule } from 'ngx-csv-parser';

import { ApiInterceptor } from './interceptors/api.interceptor';
import { UserInterceptor } from './interceptors/user.interceptor';
import { DateInterceptor } from './interceptors/date.interceptor';
import { LoaderInterceptor } from './interceptors/loader.interceptor';

import { AppRoutes } from './app.routes';

import { TranslateModule, TranslateLoader } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { CKEditorModule } from 'ckeditor4-angular';

import { GuardsModule } from 'guards/guards.module';
import { ResolversModule } from 'resolvers/resolvers.module';
import { ServicesModule } from 'services/services.module';
import { SharedModule } from 'shared/shared.module';

import { AppComponent } from './app.component';
import { AppNavbarGuestComponent } from './components/app-navbar-guest/app-navbar-guest.component';
import { AppNavbarHostComponent } from './components/app-navbar-host/app-navbar-host.component';
import { AppNavbarPlatformComponent } from './components/app-navbar-platform/app-navbar-platform.component';
import { AppNavbarKygComponent } from './components/app-navbar-kyg/app-navbar-kyg.component';
import { AppNavbarAdminComponent } from './components/app-navbar-admin/app-navbar-admin.component';
import { AppLoaderComponent } from './components/app-loader/app-loader.component';
import { AppNotFoundComponent } from './components/app-not-found/app-not-found.component';
import { AppMaintenanceComponent } from './components/app-maintenance/app-maintenance.component';
import { AppEntryComponent } from './components/app-entry/app-entry.component';

import { environment } from 'environments/environment';

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: HttpClient) {
	return new TranslateHttpLoader(http, `${environment.assets}/i18n/`);
}

@NgModule({
	imports: [
		HttpClientModule,
		BrowserModule,
		BrowserAnimationsModule,
		NgxCsvParserModule,
		ToastrModule.forRoot({
			positionClass: 'toast-bottom-right',
			timeOut: 8000,
			extendedTimeOut: 5000,
			// preventDuplicates: true
		}),
		GuardsModule.forRoot(),
		ResolversModule.forRoot(),
		ServicesModule.forRoot(),
		TranslateModule.forRoot({
			loader: {
				provide: TranslateLoader,
				useFactory: HttpLoaderFactory,
				deps: [HttpClient],
			},
		}),
		SharedModule,
		RouterModule.forRoot(AppRoutes, {
			// enableTracing: true,
			scrollPositionRestoration: 'enabled',
		}),
		CKEditorModule,
		MatPaginatorModule,
		MatSortModule,
		MatStepperModule,
		MatAutocompleteModule,
		MatFormFieldModule,
		MatInputModule,
		MatTooltipModule,
		MatMenuModule,
		GoogleMapsModule,
	],
	declarations: [
		AppComponent,
		AppEntryComponent,
		AppNavbarGuestComponent,
		AppNavbarHostComponent,
		AppNavbarPlatformComponent,
		AppLoaderComponent,
		AppNavbarAdminComponent,
		AppNotFoundComponent,
		AppMaintenanceComponent,
		AppNavbarKygComponent,
	],

	providers: [
		{ provide: HTTP_INTERCEPTORS, useClass: ApiInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: DateInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: UserInterceptor, multi: true },
		{ provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
	],

	bootstrap: [AppComponent],
})
export class AppModule {}
